// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function get(state, field) {
  switch (field) {
    case "Amount" :
      return state.amount;
    case "Note" :
      return state.note;
    case "Person" :
      return state.person;
  }
}

function set(state, field, value) {
  switch (field) {
    case "Amount" :
      return {
        amount: value,
        note: state.note,
        person: state.person
      };
    case "Note" :
      return {
        amount: state.amount,
        note: value,
        person: state.person
      };
    case "Person" :
      return {
        amount: state.amount,
        note: state.note,
        person: value
      };
  }
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function AddFinancialTransactions(props) {
  let personsAll = props.personsAll;
  let personId = props.personId;
  let onSubmit = props.onSubmit;
  let match = FormattedCurrency.useCurrency();
  let minorUnit = match.minorUnit;
  let form = Form.use({
    amount: "",
    note: "",
    person: props.initialCounterParty
  }, Validators$1.schema([
    Validators$1.required("Amount"),
    Validators$1.isNumeric(undefined, "Amount"),
    Validators$1.required("Person")
  ]), param => {
    let state = param.state;
    let amountFloat = Stdlib_Option.getOrThrow(Stdlib_Float.fromString(state.values.amount), undefined);
    let amountMinor = amountFloat * minorUnit;
    onSubmit({
      amount: amountMinor | 0,
      note: state.values.note,
      person: state.values.person
    });
  }, undefined, undefined, "OnDemand", undefined);
  return <DialogForm.make
    formId={"addFinancialTransaction"}
    heading={"Platba mezi účastníky"}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <p>
      <b>
        {props.personName}
      </b>
      {` předává peníze.`}
    </p>
    <Form.Provider.make
      value={form}
    >
      <form
        id={"addFinancialTransaction"}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={`reset ` + Styles.fieldset.grid}
        >
          <Form.Field.make
            field={"Person"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"amount"}
              inputSlot={<select
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              >
                <option
                  disabled={true}
                  value={""}
                >
                  {"Příjemce platby"}
                </option>
                {Stdlib_Array.filterMap(personsAll, param => {
                  let pId = param[0];
                  if (pId === personId) {
                    return;
                  } else {
                    return <option
                      key={pId} 
                      value={pId}
                    >
                      {param[1].name}
                    </option>;
                  }
                })}
              </select>}
              labelSlot={"Komu"}
            />}
          />
          <Form.Field.make
            field={"Amount"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"amount"}
              inputSlot={<input
                step={1.0}
                type={"number"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={"Částka"}
            />}
          />
          <Form.Field.make
            field={"Note"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"note"}
              inputSlot={<input
                type={"text"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={"Poznámka"}
            />}
          />
        </fieldset>
      </form>
    </Form.Provider.make>
  </DialogForm.make>;
}

let make = AddFinancialTransactions;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
